
import { Route, Routes } from 'react-router-dom'
import { Add, Edit, List } from './components'

export const ModuleRoutes = () => (
  <>
    <List />
    <Routes>
      <Route path="add/*" element={<Add />} />
      <Route path=":id/*" element={<Edit />} />
    </Routes>
  </>
)
